import React, { useState, useImperativeHandle, useRef } from "react";
import { Modal, Form, Row, Col } from "antd";
import { forwardRef } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import { useSelector } from "react-redux";
import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
} from "../../utils/Layouts";
import { onSubmitModal, onChange } from "../../utils/form_utilities";
import CategoryFormModal from "./CategoryFormModal";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import { product_type_options } from "../../utils/Options";
import { onCategorySearch } from "../../utils/utilities";

const url = "/api/products/";
const title = "Stock Form";
const initialValues = {
  name: "",
  category: null,
  unit_of_measure: "",
  product_type: null,
};

const StockFormModal = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const [state, setState] = useState(initialValues);
  const auth = useSelector((state) => state.auth);
  const categoryFormModal = useRef(null);
  const [options, setOptions] = useState({});
  const [index, setIndex] = useState(null);

  useImperativeHandle(
    ref,
    () => {
      return {
        open: (index) => {
          setIndex(index);
          setVisible(true);
          setState({ ...initialValues });
        },
      };
    },
    []
  );

  return (
    <div>
      <CategoryFormModal
        setField={(category) => {
          setState((prevState) => ({
            ...prevState,
            category,
          }));
        }}
        ref={categoryFormModal}
      />
      <Modal
        width={1024}
        onCancel={() => {
          setVisible(false);
        }}
        title={title}
        visible={visible}
        centered={true}
        footer={false}
      >
        <div>
          <Form
            onFinish={() =>
              onSubmitModal({
                setField: props.setField,
                setVisible,
                values: state,
                auth,
                url,
                setErrors,
                index,
              })
            }
            initialValues={initialValues}
          >
            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Name"
                  name="name"
                  error={errors.name}
                  formItemLayout={smallFormItemLayout}
                  value={state.name}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value?.toUpperCase(),
                      setState,
                    });
                  }}
                  autoComplete="off"
                />
              </Col>
              <Col span={12}>
                <SelectFieldGroup
                  label="Category"
                  value={state.category?.name}
                  onSearch={(value) =>
                    onCategorySearch({ value, options, setOptions })
                  }
                  onChange={(index) => {
                    const category = options.categories?.[index] || null;
                    setState((prevState) => ({
                      ...prevState,
                      category,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.categories}
                  column="name"
                  onAddItem={() => categoryFormModal.current.open()}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="Unit of Measure"
                  name="unit_of_measure"
                  error={errors.unit_of_measure}
                  formItemLayout={smallFormItemLayout}
                  value={state.unit_of_measure}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value?.toUpperCase(),
                      setState,
                    });
                  }}
                  autoComplete="off"
                />
              </Col>
              <Col span={12}>
                <SimpleSelectFieldGroup
                  label="Type"
                  name="product_type"
                  value={state.product_type}
                  onChange={(value) => {
                    onChange({
                      key: "product_type",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors?.approval_status}
                  formItemLayout={smallFormItemLayout}
                  options={product_type_options}
                />
              </Col>
            </Row>

            <Form.Item className="m-t-1" {...tailFormItemLayout}>
              <div className="field is-grouped">
                <div className="control">
                  <button className="button is-small is-primary">Save</button>
                </div>
              </div>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
});

export default StockFormModal;
